import { render, staticRenderFns } from "./hover-actions.vue?vue&type=template&id=18954b08&"
import script from "./hover-actions.vue?vue&type=script&lang=js&"
export * from "./hover-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports